import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { Box } from '@mui/material';
const KeepAboveFold = ({ children, targetRatio = 16 / 9, padding = 20, containerProps = {}, contentProps = {}, }) => {
    const contentRef = useRef(null);
    const containerRef = useRef(null);
    useEffect(() => {
        const handleResize = () => {
            if (contentRef.current && containerRef.current) {
                const elementRect = contentRef.current.getBoundingClientRect();
                const containerRect = containerRef.current.getBoundingClientRect();
                const maxHeight = window.innerHeight - elementRect.top - padding;
                const maxWidth = containerRect.width;
                let width = maxWidth;
                let height = width / targetRatio;
                if (height > maxHeight) {
                    height = maxHeight;
                    width = height * targetRatio;
                }
                contentRef.current.style.width = `${width}px`;
                contentRef.current.style.height = `${height}px`;
            }
        };
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [padding, targetRatio]);
    return (_jsx(Box, { ref: containerRef, sx: {
            width: '100%',
            height: '100%',
            ...containerProps?.sx,
        }, ...containerProps, children: _jsx(Box, { ref: contentRef, sx: {
                margin: 'auto',
                ...contentProps?.sx,
            }, ...contentProps, children: children }) }));
};
KeepAboveFold.defaultProps = {
    targetRatio: 16 / 9,
    padding: 20,
    containerProps: {},
    contentProps: {},
};
export default KeepAboveFold;
//# sourceMappingURL=KeepAboveFold.js.map